export function getMarkerPopUpTemplate(markerData)
{
    return `${markerData.image && markerData.nom ? 
            `<img src="${markerData.image}" alt="${markerData.nom} implantation">`
            : ''}
            <div>
                <div class="popup_contenu">
                    ${markerData.nom ? 
                    `<h2 class="titre4 alt-font text-black realisationsMap-nom">
                        ${markerData.nom}
                    </h2>` : ''
                    }
                    ${markerData.adresse && markerData.code_postal && markerData.ville ? 
                    `<div>
                        <i class="icon-map-marker-alt-solid"></i>
                        <span class="text-black">${markerData.adresse} ${markerData.code_postal} ${markerData.ville}</span>
                    </div>` : ''
                    }
                    ${markerData.telephone ? 
                    `<div>
                        <i class="icon-phone-solid"></i>
                        <span class="tag text-quaternary">Tel: ${markerData.telephone}</span>
                    </div>` : ''
                    }
                    ${markerData.email ? 
                    `<div>
                        <a href="mailto:${markerData.email}">
                            <i class="icon-envelope-solid"></i>
                            <span class="text-black">${markerData.email}</span>
                        </a>
                    </div>` : ''
                    }
                </div>
	        </div>`
}

export function getThemePath()
{
    return $('#implantationScript').data("theme-path");
}

export function markerHasPopUp(markerData)
{
    if(
        !markerData.nom && 
        !markerData.adresse &&
        !markerData.code_postal && 
        !markerData.ville &&
        !markerData.telephone &&
        !markerData.email
    ){
        return false;
    }

    return true;
}